module.exports = "/_next/static/images/1ff8fa651d0a55933af806027b00e6d8-card-background-right-lg.jpg.webp";